module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-page"
  }, [_c('div', {
    class: _vm.loading ? 'hidden' : ''
  }, [(_vm.segment !== null) ? _c('contacts', {
    attrs: {
      "mode": "segment",
      "segment": _vm.segment,
      "tableSettingsName": "segmentContacts"
    },
    on: {
      "fetchDataComplete": _vm.fetchDataComplete,
      "updateSearch": _vm.updateSearch,
      "updateFilters": _vm.updateFilters,
      "activateBusinessKitModal": _vm.activateBusinessKitModalCb,
      "activateAddToProjectModal": _vm.activateAddToProjectModalCb,
      "emitTotalTableCount": _vm.emitTotalTableCount,
      "selectedItemsChange": _vm.selectedItemsChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "segment-page-loader",
    class: _vm.loading ? '' : 'hidden'
  }, [_c('loading')], 1), _vm._v(" "), _c('business-kit-modal', {
    attrs: {
      "segment": _vm.segment,
      "sendBusinessKitModalOpen": _vm.sendBusinessKitModalOpen,
      "contactIds": _vm.contactIds,
      "totalTableCount": _vm.totalTableCount
    },
    on: {
      "closeBusinessKitModal": _vm.closeBusinessKitModal
    }
  }), _vm._v(" "), _c('add-to-project-modal', {
    attrs: {
      "segment": _vm.segment,
      "addToProjectModalOpen": _vm.addToProjectModalOpen,
      "contactIds": _vm.contactIds,
      "totalTableCount": _vm.totalTableCount
    },
    on: {
      "closeAddToProjectModal": _vm.closeAddToProjectModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ec4eb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/segments/Segment.vue
// module id = 1795
// module chunks = 0